import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { liveLessonAuthActions } from "@pcp/auth";
import { switchMap } from "rxjs";
import { Router } from "@angular/router";
import { ensureError } from "@pcp/core/util";
import { PCP_LOGGER } from "@pcp/logging";

@Injectable()
export class LiveLessonModeratorAuthEffects {

    private readonly actions$ = inject(Actions);
    private readonly router = inject(Router);

    private readonly log = inject(PCP_LOGGER).createScoped('live-lesson.moderator');

    readonly redirectOnLoginFailure$ = createEffect(() => this.actions$.pipe(
        ofType(liveLessonAuthActions.userLoginFailed),
        switchMap(action => {
            this.log.trackEvent('LoginFailed', { action });
            this.log.error('Live lesson login failed', ensureError(action.error), { action });

            return this.router.navigate(['/expired'], { replaceUrl: true, skipLocationChange: false });
        }),
    ), { dispatch: false });
}
